import { apiUrls } from 'sdk/api-urls'
import { StripeCouponModel } from 'sdk/models'
import { BaseApi } from '../base.api'
// import { StripeCouponModel } from 'sdk/models'
export class CouponApi extends BaseApi {
  public ValidateCoupon(code: string) {
    return this.GET_Request<StripeCouponModel>(`${apiUrls.payment.fetchCouponById(code)}`)
  }
}
